import React, {Fragment, useEffect} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {toast} from 'react-toastify';

const notify = (text, type, seconds) => {
    // Map the alert type to the matching toast style. Previously everything
    // that wasn't 'success' fell through to toast.error, so 'info' and
    // 'warning' alerts (e.g. "Hisobot tayyorlanmoqda...") flashed red as if
    // they were errors.
    const options = { role: 'alert', seconds };

    switch (type) {
        case 'success':
            return toast.success(text, { ...options, pauseOnFocusLoss: false });
        case 'info':
            return toast.info(text, { ...options, pauseOnFocusLoss: false });
        case 'warning':
            return toast.warning(text, { ...options, pauseOnFocusLoss: true });
        default: // 'danger' / 'error' / anything unexpected
            return toast.error(text, { ...options, pauseOnFocusLoss: true });
    }
};
const dismissAll = () => toast.dismiss();
const Alert = ({alerts}) => {

    dismissAll();

    useEffect(() => {
        if (alerts !== null && alerts.length > 0) {
            const alert = alerts[0];
            notify(alert.msg, alert.type, alert?.seconds)
            return <Fragment key={alert.id}/>
        }
    }, [alerts])

    return null;
}


Alert.propTypes = {
    alerts: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
    alerts: state.alert,
});

export default connect(mapStateToProps)(Alert);
